import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import {
  memo,
  useEffect,
} from 'react'
import { useInView } from 'react-intersection-observer'

import Bar from '@/components/base/Bar'
import useTrans from '@/hooks/useTrans'

import Pool from './pool'
import PoolSkeleton from './pool.skeleton'
import { LiquidityPoolsPageProps } from './types'

const View = (props: LiquidityPoolsPageProps) => {
  const {
    poolsData,
    inputValue,
    setInputValue,
    isLoading,
    fetchNextPage,
    isEmptyPools,
  } = props
  const trans = useTrans()
  const { ref, inView } = useInView()

  useEffect(() => {
    if (inView) {
      fetchNextPage()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView])

  return (
    <Box className="mt-6 mb-3">
      <Bar
        inputValue={inputValue}
        setInputValue={setInputValue}
        tabActive="pools"
        className="mb-4"
      />
      <Stack className="h-full" justifyContent="space-between" alignItems="center">
        <Box className="w-full">
          <Stack justifyContent="space-between" alignItems="center">
            <Box data-testid="container-pool-list" className="w-full">
              {!isLoading && isEmptyPools(poolsData) && (
                <Stack className="m-8" justifyContent="center" alignItems="center">
                  <Typography>
                    {inputValue ? trans.liquidity.no_results_found : trans.liquidity.no_pools_found}
                  </Typography>
                </Stack>
              )}
              <Grid container spacing={!isEmptyPools(poolsData) || isLoading ? 2 : 0}>
                {poolsData?.pages &&
                  poolsData?.pages?.length > 0 &&
                  poolsData.pages.map((poolsData) =>
                    poolsData.pools.map((pool) => <Pool key={pool.pool_address} pool={pool} />),
                  )}
                {isLoading && (
                  <PoolSkeleton
                    numPools={poolsData?.pages.reduce((prev, curr) => prev + curr.pools.length, 0)}
                  />
                )}
                <Stack ref={ref} />
              </Grid>
            </Box>
          </Stack>
        </Box>
      </Stack>
    </Box>
  )
}

export default memo(View)
